import { Lock, LockOpen, Warning, X } from '@phosphor-icons/react';
import { ClipLoader } from 'react-spinners';
import { DebitCardWithTruck } from '../../../../../../../types/apiTypes';

interface CardControlsProps {
  setPopupVisible: (visible: boolean) => void;
  setNewCardPopupVisible: (visible: boolean) => void;
  setActivateCardPopupVisible: (visible: boolean) => void;
  currCard: DebitCardWithTruck | null;
  loadingFreeze: boolean;
  loadingCancel: boolean;
  freezeCard: (debit_card_id: string, frozen: boolean) => Promise<void>;
  cancelCard: (debit_card_id: string, last_four_digits: string) => void;
  isPreActive: boolean;
}

const CardControls = ({
  setPopupVisible,
  setNewCardPopupVisible,
  setActivateCardPopupVisible,
  currCard,
  loadingFreeze,
  loadingCancel,
  freezeCard,
  cancelCard,
  isPreActive,
}: CardControlsProps) => {
  if (currCard?.is_cancelled)
    return (
      <div className="flex w-[30%] flex-col items-center justify-center" />
    );
  return (
    <div className="flex w-full max-w-[220px] flex-col items-start justify-center gap-y-1">
      {currCard?.physical_card_activated_timestamp === null && (
        <button
          onClick={(e: any) => {
            e.stopPropagation();
            setPopupVisible(false);
            setActivateCardPopupVisible(true);
          }}
          disabled={isPreActive}
          className="flex flex-row items-center space-x-1 rounded-lg border border-orange-500 px-4 py-2 text-left align-middle text-orange-600 hover:bg-orange-50"
        >
          <img
            alt="card-add"
            src="/card-tick.svg"
            className="h-[20px] w-[20px]"
            style={{
              filter:
                'invert(30%) sepia(100%) saturate(800%) hue-rotate(359deg) brightness(97%) contrast(101%)',
            }}
          />
          <p>Activate Physical Card</p>
        </button>
      )}

      {!currCard?.frozen ? (
        <button
          onClick={async (e: any) => {
            e.stopPropagation();
            await freezeCard(currCard?.debit_card_id ?? '', true);
            setPopupVisible(false);
          }}
          disabled={isPreActive}
          className="flex flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-primary hover:bg-gray-100 hover:disabled:cursor-not-allowed hover:disabled:opacity-50"
        >
          <Lock size={20} />
          <p>Freeze Debit Card</p>
          {loadingFreeze && (
            <ClipLoader
              color="#1D213B"
              loading={loadingFreeze}
              size={20}
              aria-label="Loading Spinner"
              data-testid="loader"
              className="h-full w-full justify-center"
            />
          )}
        </button>
      ) : (
        <button
          onClick={async (e: any) => {
            e.stopPropagation();
            await freezeCard(currCard?.debit_card_id ?? '', false);
            setPopupVisible(false);
          }}
          disabled={isPreActive}
          className="flex flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-primary hover:bg-gray-100 hover:disabled:cursor-not-allowed hover:disabled:opacity-50"
        >
          <LockOpen size={20} />
          <p>Unfreeze Debit Card</p>
          {loadingFreeze && (
            <ClipLoader
              color="#1D213B"
              loading={loadingFreeze}
              size={20}
              aria-label="Loading Spinner"
              data-testid="loader"
              className="h-full w-full justify-center"
            />
          )}
        </button>
      )}
      <button
        onClick={async (e: any) => {
          e.stopPropagation();
          await cancelCard(
            currCard?.debit_card_id ?? '',
            currCard?.last_four_digits ?? ''
          );
          setPopupVisible(false);
        }}
        disabled={isPreActive}
        className="flex flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-danger hover:bg-gray-100 hover:disabled:cursor-not-allowed hover:disabled:opacity-50"
      >
        <X size={20} className="h-[20px] min-h-[20px] w-[20px] min-w-[20px]" />
        <p>Cancel Card</p>
        {loadingCancel && (
          <ClipLoader
            color="#1D213B"
            loading={loadingCancel}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
            className="h-full w-full justify-center"
          />
        )}
      </button>
      {!currCard?.is_cancelled &&
        currCard?.physical_card_activated_timestamp === null && (
          <div className="flex w-full flex-row items-center justify-center rounded-[8px] border-[1px] border-[#E2660C] bg-[#FCF0E7] px-2 py-1 align-middle backdrop-blur-[24%]">
            <Warning size={40} className="mr-1.5 text-[#E2660C]" />
            <p className="text-[12px] text-primary">
              Your physical card is not yet activated. Please activate it once
              you’ve received it.
            </p>
          </div>
        )}
    </div>
  );
};

export default CardControls;
